"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7712],{

/***/ 68447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ VoucherColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80711);


const VoucherColored = (props) => {
    return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M14.563 20C14.785 19.1374 15.5681 18.5 16.5 18.5C17.4319 18.5 18.215 19.1374 18.437 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H18.437C18.215 4.86261 17.4319 5.5 16.5 5.5C15.5681 5.5 14.785 4.86261 14.563 4L4 4C2.89543 4 2 4.89543 2 6L2 18C2 19.1046 2.89543 20 4 20H14.563ZM10.3057 13.6328C10.3057 13.3757 10.2422 13.1738 10.1152 13.0273C9.98828 12.8809 9.7653 12.7425 9.44629 12.6123C9.12728 12.4821 8.83268 12.3503 8.5625 12.2168C8.29232 12.0833 8.05957 11.9287 7.86426 11.7529C7.66895 11.5771 7.51921 11.3737 7.41504 11.1426C7.31087 10.9115 7.25879 10.6315 7.25879 10.3027C7.25879 9.7526 7.44434 9.30013 7.81543 8.94531C8.18652 8.58724 8.68131 8.37891 9.2998 8.32031V7.29004H10.0762V8.33984C10.6719 8.42773 11.139 8.6735 11.4775 9.07715C11.8193 9.47754 11.9902 9.98698 11.9902 10.6055H10.3398C10.3398 10.2669 10.2747 10.0065 10.1445 9.82422C10.0143 9.64193 9.82878 9.55078 9.58789 9.55078C9.37305 9.55078 9.2054 9.61914 9.08496 9.75586C8.96777 9.88932 8.90918 10.0749 8.90918 10.3125C8.90918 10.5534 8.97754 10.7454 9.11426 10.8887C9.25098 11.0286 9.4707 11.1637 9.77344 11.2939C10.0762 11.4209 10.361 11.5544 10.6279 11.6943C10.8981 11.8311 11.1309 11.9873 11.3262 12.1631C11.5215 12.3389 11.6745 12.5439 11.7852 12.7783C11.8958 13.0127 11.9512 13.2943 11.9512 13.623C11.9512 14.1797 11.7738 14.6338 11.4189 14.9854C11.0674 15.3369 10.5872 15.542 9.97852 15.6006V16.582H9.20215V15.5957C8.49251 15.5208 7.94727 15.2783 7.56641 14.8682C7.1888 14.4548 7 13.9111 7 13.2373H8.64551C8.64551 13.6084 8.72689 13.8916 8.88965 14.0869C9.05566 14.279 9.29004 14.375 9.59277 14.375C9.81413 14.375 9.98828 14.3099 10.1152 14.1797C10.2422 14.0462 10.3057 13.8639 10.3057 13.6328ZM17.2002 16.4C17.2002 16.7314 16.9316 17 16.6002 17C16.2688 17 16.0002 16.7314 16.0002 16.4V15.52C16.0002 15.1886 16.2688 14.92 16.6002 14.92C16.9316 14.92 17.2002 15.1886 17.2002 15.52V16.4ZM17.2002 12.88C17.2002 13.2114 16.9316 13.48 16.6002 13.48C16.2688 13.48 16.0002 13.2114 16.0002 12.88L16.0002 11.12C16.0002 10.7886 16.2688 10.52 16.6002 10.52C16.9316 10.52 17.2002 10.7886 17.2002 11.12V12.88ZM17.2002 8.48C17.2002 8.81137 16.9316 9.08 16.6002 9.08C16.2688 9.08 16.0002 8.81137 16.0002 8.48V7.6C16.0002 7.26863 16.2688 7 16.6002 7C16.9316 7 17.2002 7.26863 17.2002 7.6V8.48Z',
                    fill: 'url(#paint0_linear)',
                },
            },
            {
                tag: 'defs',
                attr: {},
                child: [
                    {
                        tag: 'linearGradient',
                        attr: {
                            id: 'paint0_linear',
                            x1: '12',
                            y1: '20',
                            x2: '12',
                            y2: '4',
                            gradientUnits: 'userSpaceOnUse',
                        },
                        child: [
                            { tag: 'stop', attr: { stopColor: '#FF2B2B' } },
                            { tag: 'stop', attr: { offset: '1', stopColor: '#FF2E6C' } },
                        ],
                    },
                ],
            },
        ],
    })(props);
};




/***/ }),

/***/ 14522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ProductVariantsMobile; }
/* harmony export */ });
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _VariantItem_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77760);




const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div ``;
const VariantWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div `
  display: flex;
  flex-wrap: wrap;
  overflow-y: hidden;
  overflow-x: auto;
`;
const SelectedVariant = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div `
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  color: #82869e;
  margin-bottom: 4px;
  text-transform: uppercase;
`;
const ProductVariantsMobile = ({ configuration, onSelectVariant, index, className, }) => {
    const selectedOption = configuration.options.find((variant) => {
        return variant.selected;
    });
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, { className: className },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectedVariant, null,
            configuration.name,
            selectedOption ? `: ${selectedOption.value}` : ``),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(VariantWrapper, null, configuration.options.map((variant) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_VariantItem_es_js__WEBPACK_IMPORTED_MODULE_2__/* .VariantItem */ .D, { key: variant.optionId, option: variant, onSelectVariant: onSelectVariant, index: index }))))));
};




/***/ }),

/***/ 77760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ VariantItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95889);



const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ isThumbnail, theme, isVisible, isActive }) => `
    width: ${isThumbnail ? '32px' : 'fit-content'};
    height: ${isThumbnail ? '32px' : 'fit-content'};
    border: 1px ${isActive ? theme.brand.primary : '#e0e0e0'} solid;
    position: relative;
    border-radius: 4px;

    margin: 0 8px 12px 0;
    padding: ${isThumbnail ? '4px' : '8px 16px'};
    color: 'black';
    background-color: ${isVisible || isActive ? '#fff' : '#e0e0e0'};
    text-transform: capitalize;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: ${isVisible || isActive ? 'pointer' : 'not-allowed'};
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
    }
`);
const Value = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span ``;
const VariantItem = ({ option, index, onSelectVariant }) => {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, { isActive: option.selected, isVisible: option.visible, onClick: () => onSelectVariant(option, index), isThumbnail: !!option.thumbnailUrl }, option.thumbnailUrl ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .LazyImage */ .w, { src: option.thumbnailUrl }))) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Value, null, option.value))));
};




/***/ }),

/***/ 27975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hY": function() { return /* binding */ renderIcon; },
/* harmony export */   "lX": function() { return /* binding */ getPromoTitle; },
/* harmony export */   "$1": function() { return /* binding */ getConditionText; },
/* harmony export */   "Mo": function() { return /* binding */ PromotionOption; }
/* harmony export */ });
/* unused harmony export getTextDiscount */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25702);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68447);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48818);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97204);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17963);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: 64px;\n  width: 64px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 12px;\n  border-radius: 4px;\n  background-color: #fbecec;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-top: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var getTextDiscount = function(moneyPromotion) {
    var textDiscount;
    if (moneyPromotion.discountType === 'percent') {
        // Giảm %
        textDiscount = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)('Giảm'),
                " ",
                moneyPromotion.percent,
                "%",
                !!moneyPromotion.maxDiscount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        ' ',
                        (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)('tối đa'),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Currency */ .F, {
                            value: moneyPromotion.maxDiscount || 0
                        })
                    ]
                })
            ]
        });
    } else {
        // Giảm tiền
        textDiscount = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)('Giảm'),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Currency */ .F, {
                    value: moneyPromotion.money || 0
                })
            ]
        });
    }
    return textDiscount;
};
var renderIcon = function(promo) {
    var ref, ref1;
    var ref2 = promo || {}, _benefit = ref2.benefit, benefit = _benefit === void 0 ? {} : _benefit;
    var isGiftOrMoneyBenefit = ((ref = benefit.money) === null || ref === void 0 ? void 0 : ref.length) || ((ref1 = benefit.items) === null || ref1 === void 0 ? void 0 : ref1.length);
    return isGiftOrMoneyBenefit ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .GiftColored */ .x, {
        size: 32
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .VoucherColored */ .C, {
        size: 32
    });
};
var getPromoTitle = function(promo) {
    var ref, ref3, ref4;
    var ref5 = promo || {}, _benefit = ref5.benefit, benefit = _benefit === void 0 ? {} : _benefit;
    var titles = [];
    // Example: Giảm 10.000đ, tặng 2x quà, 1x voucher
    // Money
    if ((ref = benefit.money) === null || ref === void 0 ? void 0 : ref.length) {
        titles.push(getTextDiscount(benefit.money[0]));
    }
    var prefixForGiftVoucher = "".concat(titles.length ? (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)('Tặng').toLowerCase() : (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)('Tặng'), " ");
    // Gift
    if ((ref3 = benefit.items) === null || ref3 === void 0 ? void 0 : ref3.length) {
        var itemTitle = prefixForGiftVoucher;
        prefixForGiftVoucher = '';
        benefit.items.forEach(function(param) {
            var quantity = param.quantity, name = param.name;
            itemTitle += "".concat(quantity, "x ").concat(name, ", ");
        });
        titles.push(itemTitle.substr(0, itemTitle.length - 2));
    }
    // Voucher
    if ((ref4 = benefit.voucher) === null || ref4 === void 0 ? void 0 : ref4.name) {
        var voucher = benefit.voucher;
        titles.push("".concat(prefixForGiftVoucher).concat(voucher.quantity, "x ").concat(voucher.name));
    }
    var totalBenefits = titles.length;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: titles.map(function(title, index) {
            var isLastTitle = index === totalBenefits - 1;
            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    title,
                    !isLastTitle && ', '
                ]
            }, index));
        })
    }));
};
var getConditionText = function(condition) {
    var ref = condition || {}, blockSize = ref.blockSize, minQuantity = ref.minQuantity;
    if (blockSize <= 1 && minQuantity <= 1) return null;
    return (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)(blockSize !== 1 ? 'Mua {{quantity}} sản phẩm để nhận khuyến m\xe3i' : 'Mua từ {{quantity}} sản phẩm để nhận khuyến m\xe3i', {
        quantity: blockSize === 1 ? minQuantity : blockSize
    });
};
var PromotionOption = function(_param) {
    var promotion = _param.promotion, className = _param.className, _active = _param.active, active = _active === void 0 ? false : _active, onClick = _param.onClick, props = _objectWithoutProperties(_param, [
        "promotion",
        "className",
        "active",
        "onClick"
    ]);
    var renderPromotionContent = function() {
        var conditionText = getConditionText(promotion === null || promotion === void 0 ? void 0 : promotion.condition);
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PromotionContent, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {
                            active: active,
                            children: getPromoTitle(promotion)
                        }),
                        conditionText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConditionText, {
                            children: conditionText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ExpiredAndApplied, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExpiredAt, {
                            children: "".concat((0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)('HSD'), ": ").concat(new Date(promotion.endedAt).toLocaleDateString('vi'))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CTA, {
                            children: active ? (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)('Bỏ chọn') : (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)('\xc1p dụng')
                        })
                    ]
                })
            ]
        }));
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Item, _objectSpread({
        className: className,
        isActive: active,
        onClick: function() {
            return onClick(promotion.id);
        }
    }, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
                children: renderIcon(promotion)
            }),
            renderPromotionContent()
        ]
    })));
};

var Item = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(function(param) {
    var isActive = param.isActive, theme = param.theme;
    return "\n    width: 100%;\n    display: flex;\n    margin-top: 10px;\n    padding: 12px;\n    border-radius: 8px;\n  \n    background-color: ".concat(isActive ? '#FFF5F6' : '#ffffff', ";\n    border: 1px solid ").concat(isActive ? theme.brand.primary : '#E4E5F0', ";\n    cursor: pointer;\n  ");
});
var IconWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(_templateObject());
var PromotionContent = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(_templateObject1());
var maxLineCss = function(maxLines) {
    return "\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: ".concat(maxLines, ";\n  ");
};
var Label = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(function(param) {
    var active = param.active, theme = param.theme;
    return "\n      font-size: 13px;\n      font-weight: 500;\n      line-height: 20px;\n      ".concat(maxLineCss(2), "\n      color: ").concat(active ? '#1B1D29' : theme.colors.text, ";\n    ");
});
var ConditionText = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(function(param) {
    var theme = param.theme;
    return "\n    margin-top: 4px;\n    font-size: 12px;\n    line-height: 16px;\n    color: ".concat(theme.colors.neutral, ";\n    ").concat(maxLineCss(2), "\n  ");
});
var ExpiredAndApplied = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(_templateObject2());
var ExpiredAt = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(function(param) {
    var theme = param.theme;
    return "\n      font-size: 12px;\n      line-height: 16px;\n      color: ".concat(theme.colors.neutral, ";\n    ");
});
var CTA = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div(function(param) {
    var theme = param.theme;
    return "\n      font-size: 13px;\n      line-height: 20px;\n      color: ".concat(theme.colors.link500, ";\n    ");
});


/***/ }),

/***/ 79319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useCartCombo; }
/* harmony export */ });
/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71421);
/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17963);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74721);




function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var getTextWarning = function(e) {
    var ref;
    var code = e === null || e === void 0 ? void 0 : (ref = e.code) === null || ref === void 0 ? void 0 : ref.toString();
    switch(code){
        case '400113':
            return (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)('sites.shop-front.hooks.useCartCombo.0');
        case '400114':
            return (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)('sites.shop-front.hooks.useCartCombo.1');
        case '400116':
            return (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)('sites.shop-front.hooks.useCartCombo.2');
        default:
            return null;
    }
};
var useCartCombo = function(mainSku) {
    var cart = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useCart */ .jD)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), visiblePopupWarning = ref[0], setVisiblePopupWarning = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), textWarning = ref1[0], setTextWarning = ref1[1];
    var onClosePopupWarning = function() {
        setVisiblePopupWarning(false);
        setTextWarning(undefined);
    };
    var onAddComboToCart = !mainSku ? null : function() {
        var _ref = _asyncToGenerator(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(type, payload) {
            var override, mainPayload, warning, _args = arguments;
            return _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        override = _args.length > 2 && _args[2] !== void 0 ? _args[2] : true;
                        if (!(type === 'autogen')) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 4;
                        return cart.onAddMultiToCart(payload.comboLineItems);
                    case 4:
                        _ctx.next = 16;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        mainPayload = {
                            override: override,
                            groups: [
                                {
                                    quantity: 1,
                                    promotionId: payload.promotionId,
                                    products: payload.comboLineItems.map(function(el, index) {
                                        return {
                                            sku: el.sku,
                                            quantity: el.quantity,
                                            isPrimary: index === 0
                                        };
                                    })
                                }, 
                            ]
                        };
                        _ctx.next = 10;
                        return cart.onAddToCart(mainPayload);
                    case 10:
                        _ctx.next = 16;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](6);
                        if (!override) {
                            warning = getTextWarning(_ctx.t0);
                            if (warning) {
                                setTextWarning(warning);
                                setVisiblePopupWarning(true);
                            }
                        }
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    6,
                    12
                ]
            ]);
        }));
        return function(type, payload) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        cart: cart,
        onAddComboToCart: onAddComboToCart,
        visiblePopupWarning: visiblePopupWarning,
        onClosePopupWarning: onClosePopupWarning,
        textWarning: textWarning
    };
};


/***/ }),

/***/ 97776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JC": function() { return /* binding */ useDetailCombo; },
/* harmony export */   "zX": function() { return /* binding */ useAutogenSelectedProduct; },
/* harmony export */   "Hz": function() { return /* binding */ useDynamicSelectedProduct; }
/* harmony export */ });
/* unused harmony export useAutogenPrices */
/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71421);
/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43476);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12354);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69663);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34069);
/* harmony import */ var _useDiscovery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7275);






function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var useDetailCombo = function(type, payload) {
    var getProcessEnv = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)().getProcessEnv;
    var calculatePriceByCart = getProcessEnv('CALCULATE_PRICE_BY_CART') === 'true';
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), products = ref8[0], setProducts = ref8[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(payload), payloadCombo = ref1[0], setPayloadCombo = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), comboPromotion = ref2[0], setComboPromotion = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), supplierRetailPrice = ref3[0], setSupplierRetailPrice = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), latestPrice = ref4[0], setLatestPrice = ref4[1];
    var skus = ((payloadCombo === null || payloadCombo === void 0 ? void 0 : payloadCombo.comboLineItems) || []).map(function(el) {
        return el.sku;
    });
    var ref5 = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)(), terminal = ref5.terminal, location = ref5.location;
    var discoveryService = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useServices */ .Su)().discoveryService;
    var fetcherListProduct = function(_) {
        return Promise.all(skus.map(function(sku) {
            return discoveryService.getProduct({
                sku: sku,
                terminalCode: terminal,
                location: location
            }, calculatePriceByCart).then(function(res) {
                var ref;
                return res === null || res === void 0 ? void 0 : (ref = res.result) === null || ref === void 0 ? void 0 : ref.product;
            });
        }));
    };
    var ref6 = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(type === 'autogen' && (skus === null || skus === void 0 ? void 0 : skus.length) ? [
        "".concat(discoveryService.getBaseUrl, "/list-product"),
        JSON.stringify(skus)
    ] : null, fetcherListProduct, {
        revalidateOnFocus: false
    }), dataAutogenCombo = ref6.data, errorAutogen = ref6.error;
    var ref7 = (0,_useDiscovery__WEBPACK_IMPORTED_MODULE_5__/* .useRecommendationComboDetail */ .lR)(payloadCombo, type === 'dynamic'), _result = ref7.result, dataDynamicCombo = _result.combo, isLoadingDynamicCombo = ref7.isLoading;
    var updatePrice = function(newProducts) {
        setSupplierRetailPrice(newProducts.reduce(function(acc, curr) {
            return acc + (curr.quantity || 0) * curr.supplierRetailPrice;
        }, 0));
        setLatestPrice(newProducts.reduce(function(acc, curr) {
            return acc + (curr.quantity || 0) * curr.latestPrice;
        }, 0));
    };
    var onChangeQuantity = function(sku, value) {
        if (type === 'autogen') {
            var newProducts = products.map(function(el) {
                if (el.sku === sku) {
                    return _objectSpread({}, el, {
                        quantity: value
                    });
                }
                return el;
            });
            setProducts(newProducts);
            updatePrice(newProducts);
        }
    };
    var onChangeAutogenProduct = function(index, newProduct) {
        var newProducts = products.map(function(el, idx) {
            if (index === idx) return newProduct;
            return el;
        });
        setProducts(newProducts);
        setPayloadCombo({
            comboLineItems: newProducts.map(function(prod) {
                return {
                    sku: prod.sku,
                    quantity: prod.quantity,
                    selectPromotionId: prod.selectionPromotionId
                };
            })
        });
        updatePrice(newProducts);
    };
    var onChangeDynamicProduct = function(newPayload) {
        setPayloadCombo(newPayload);
    };
    var convertProductsAutogenCombo = function() {
        if (!dataAutogenCombo) return null;
        var newProducts = dataAutogenCombo.map(function(prod) {
            var ref22, ref9, ref10, ref11, ref12, ref13, ref14;
            var sku = prod.productInfo.sku;
            var quantity = ((ref22 = payloadCombo.comboLineItems.find(function(line) {
                return line.sku === sku;
            })) === null || ref22 === void 0 ? void 0 : ref22.quantity) || 1;
            var convertedProduct = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .convertProductDetail */ .NP)(prod);
            var selectionPromotion = convertedProduct === null || convertedProduct === void 0 ? void 0 : (ref9 = convertedProduct.selectionPromotions) === null || ref9 === void 0 ? void 0 : ref9[0];
            var gifts = [];
            var vouchers = [];
            (prod.defaultPromotions || []).forEach(function(el) {
                var ref, ref19, ref20, ref21;
                if (!!(el === null || el === void 0 ? void 0 : (ref = el.benefit) === null || ref === void 0 ? void 0 : (ref19 = ref.gifts) === null || ref19 === void 0 ? void 0 : ref19.length)) {
                    gifts = _toConsumableArray(gifts).concat(_toConsumableArray(el.benefit.gifts));
                }
                if (el === null || el === void 0 ? void 0 : (ref20 = el.benefit) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.voucher) === null || ref21 === void 0 ? void 0 : ref21.name) {
                    vouchers.push(el.benefit.voucher);
                }
            });
            if (selectionPromotion) {
                var ref15, ref16, ref17, ref18;
                if (!!(selectionPromotion === null || selectionPromotion === void 0 ? void 0 : (ref15 = selectionPromotion.benefit) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.gifts) === null || ref16 === void 0 ? void 0 : ref16.length)) {
                    gifts = _toConsumableArray(gifts).concat(_toConsumableArray(selectionPromotion.benefit.gifts));
                }
                if (selectionPromotion === null || selectionPromotion === void 0 ? void 0 : (ref17 = selectionPromotion.benefit) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.voucher) === null || ref18 === void 0 ? void 0 : ref18.name) {
                    vouchers.push(selectionPromotion.benefit.voucher);
                }
            }
            return {
                sku: sku,
                quantity: quantity,
                image: prod.productInfo.imageUrl,
                name: prod.productInfo.name,
                selectedVariant: (convertedProduct.selected || []).map(function(v) {
                    return v.value;
                }),
                supplierRetailPrice: Number(prod === null || prod === void 0 ? void 0 : (ref10 = prod.prices) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.supplierRetailPrice) || 0,
                latestPrice: Number(prod === null || prod === void 0 ? void 0 : (ref12 = prod.prices) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.latestPrice) || 0,
                selectionPromotionId: selectionPromotion === null || selectionPromotion === void 0 ? void 0 : selectionPromotion.id,
                defaultPromotions: (convertedProduct === null || convertedProduct === void 0 ? void 0 : convertedProduct.defaultPromotions) || [],
                selectionPromotion: selectionPromotion,
                selectionPromotions: (convertedProduct === null || convertedProduct === void 0 ? void 0 : convertedProduct.selectionPromotions) || [],
                allowSelectPromotion: (convertedProduct === null || convertedProduct === void 0 ? void 0 : (ref14 = convertedProduct.selectionPromotions) === null || ref14 === void 0 ? void 0 : ref14.length) > 0,
                totalAvailable: prod.totalAvailable,
                gifts: gifts,
                vouchers: vouchers
            };
        });
        setProducts(newProducts);
        updatePrice(newProducts);
    };
    var convertProductsDynamicCombo = function() {
        if (!dataDynamicCombo) return null;
        var newProducts = dataDynamicCombo.products.map(function(comboItem) {
            var ref31, ref23, ref24, ref25, ref26, ref27;
            var sku = comboItem.product.productInfo.sku;
            var quantity = comboItem.quantity;
            var convertedProduct = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .convertProductDetail */ .NP)(comboItem.product);
            var gifts = [];
            var vouchers = [];
            (comboItem.product.promotions || []).forEach(function(el) {
                var ref, ref28, ref29, ref30;
                if (!!(el === null || el === void 0 ? void 0 : (ref = el.benefit) === null || ref === void 0 ? void 0 : (ref28 = ref.gifts) === null || ref28 === void 0 ? void 0 : ref28.length)) {
                    gifts = _toConsumableArray(gifts).concat(_toConsumableArray(el.benefit.gifts));
                }
                if (el === null || el === void 0 ? void 0 : (ref29 = el.benefit) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.voucher) === null || ref30 === void 0 ? void 0 : ref30.name) {
                    vouchers.push(el.benefit.voucher);
                }
            });
            return {
                sku: sku,
                quantity: quantity,
                image: comboItem.product.productInfo.imageUrl,
                name: comboItem.product.productInfo.name,
                selectedVariant: (convertedProduct.selected || []).map(function(v) {
                    return v.value;
                }),
                supplierRetailPrice: Number((ref31 = comboItem.product) === null || ref31 === void 0 ? void 0 : (ref23 = ref31.prices) === null || ref23 === void 0 ? void 0 : (ref24 = ref23[0]) === null || ref24 === void 0 ? void 0 : ref24.supplierRetailPrice) || 0,
                latestPrice: Number((ref25 = comboItem.product) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.prices) === null || ref26 === void 0 ? void 0 : (ref27 = ref26[0]) === null || ref27 === void 0 ? void 0 : ref27.latestPrice) || 0,
                defaultPromotions: comboItem.product.promotions || [],
                selectionPromotions: [],
                allowSelectPromotion: false,
                totalAvailable: comboItem.product.totalAvailable,
                gifts: gifts,
                vouchers: vouchers
            };
        });
        setComboPromotion(_objectSpread({}, dataDynamicCombo.promotion, {
            id: dataDynamicCombo.id
        }));
        setProducts(newProducts);
        setSupplierRetailPrice(Number(dataDynamicCombo.supplierRetailPrice) || 0);
        setLatestPrice(Number(dataDynamicCombo.latestPrice) || 0);
    };
    var onFinish = function(callback) {
        callback(type, payloadCombo);
    };
    var convertProducts = function() {
        if (type === 'autogen') return convertProductsAutogenCombo();
        else return convertProductsDynamicCombo();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setPayloadCombo(payload);
    }, [
        JSON.stringify(payload)
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        convertProducts();
    }, [
        JSON.stringify(dataAutogenCombo),
        JSON.stringify(dataDynamicCombo)
    ]);
    return {
        payloadCombo: payloadCombo,
        products: products,
        latestPrice: latestPrice,
        supplierRetailPrice: supplierRetailPrice,
        onChangeQuantity: onChangeQuantity,
        comboPromotion: comboPromotion,
        onChangeAutogenProduct: onChangeAutogenProduct,
        onChangeDynamicProduct: onChangeDynamicProduct,
        onFinish: onFinish,
        loadingCombo: type === 'autogen' ? !errorAutogen && !dataAutogenCombo : isLoadingDynamicCombo
    };
};
var useAutogenPrices = function(sku1, supplierRetailPrice, selectPromotionId1) {
    var ref = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)(), terminal1 = ref.terminal, getProcessEnv = ref.getProcessEnv;
    var calculatePriceByCart = getProcessEnv('CALCULATE_PRICE_BY_CART') === 'true';
    var cartService = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useServices */ .Su)().cartService;
    var ref32 = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(calculatePriceByCart && !!sku1 && !!terminal1 ? [
        "cart_service/calculate_price",
        sku1,
        terminal1,
        selectPromotionId1
    ] : null, function() {
        var _ref = _asyncToGenerator(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_, sku, terminal, selectPromotionId) {
            return _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return cartService.calculatePrice({
                            terminal: terminal
                        }, {
                            sku: sku,
                            selectPromotionId: selectPromotionId
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, sku, terminal, selectPromotionId) {
            return _ref.apply(this, arguments);
        };
    }(), {
        revalidateOnFocus: false
    }), latestPrice = ref32.data;
    var ref33 = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(calculatePriceByCart && !!sku1 && !!terminal1 ? [
        "cart_service/calculate_save_without_selection_promotion",
        sku1,
        terminal1, 
    ] : null, function() {
        var _ref = _asyncToGenerator(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_, sku, terminal) {
            var priceWithoutSelectionPromotion;
            return _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return cartService.calculatePrice({
                            terminal: terminal
                        }, {
                            sku: sku,
                            selectPromotionId: null
                        });
                    case 2:
                        priceWithoutSelectionPromotion = _ctx.sent;
                        if (!(!isNaN(+supplierRetailPrice) && !isNaN(+priceWithoutSelectionPromotion))) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            saveWithoutSelectionPromotion: +supplierRetailPrice - priceWithoutSelectionPromotion,
                            priceWithoutSelectionPromotion: priceWithoutSelectionPromotion
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, sku, terminal) {
            return _ref.apply(this, arguments);
        };
    }(), {
        revalidateOnFocus: false
    }), tmp = ref33.data, ref34 = tmp === void 0 ? {} : tmp, saveWithoutSelectionPromotion = ref34.saveWithoutSelectionPromotion, priceWithoutSelectionPromotion1 = ref34.priceWithoutSelectionPromotion;
    return {
        latestPrice: latestPrice,
        saveWithoutSelectionPromotion: saveWithoutSelectionPromotion,
        priceWithoutSelectionPromotion: priceWithoutSelectionPromotion1
    };
};
var useAutogenSelectedProduct = function(index1, prod) {
    var getProcessEnv = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)().getProcessEnv;
    var calculatePriceByCart = getProcessEnv('CALCULATE_PRICE_BY_CART') === 'true';
    var ref49 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(prod.sku), skuVariant = ref49[0], setSkuVariant = ref49[1];
    var ref35 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(prod.selectionPromotionId), selectionPromotionId = ref35[0], setSelectionPromotionId = ref35[1];
    var ref36 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(prod.quantity), quantity = ref36[0], setQuantity = ref36[1];
    var ref37 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), convertProduct = ref37[0], setConvertProduct = ref37[1];
    var ref38 = (0,_useDiscovery__WEBPACK_IMPORTED_MODULE_5__/* .useDiscoveryProduct */ .uD)(skuVariant, calculatePriceByCart), product = ref38.result.product, isLoading = ref38.isLoading;
    var ref39 = useAutogenPrices(prod === null || prod === void 0 ? void 0 : prod.sku, prod === null || prod === void 0 ? void 0 : prod.supplierRetailPrice, selectionPromotionId), latestPrice = ref39.latestPrice, priceWithoutSelectionPromotion = ref39.priceWithoutSelectionPromotion, saveWithoutSelectionPromotion = ref39.saveWithoutSelectionPromotion;
    var onChangeVariant = function(variant, index) {
        var newSku = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .getNewVariant */ .A8)(product, variant, index);
        if (!!newSku) {
            setSkuVariant(newSku);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref50, ref40, ref41, ref42, ref43, ref44, ref45;
        if (!product) return;
        var convertedProduct = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .convertProductDetail */ .NP)(product);
        var selectionPromotion = ((convertedProduct === null || convertedProduct === void 0 ? void 0 : convertedProduct.selectionPromotions) || []).find(function(el) {
            return el.id === selectionPromotionId;
        });
        var gifts = [];
        var vouchers = [];
        (product.defaultPromotions || []).forEach(function(el) {
            var ref, ref46, ref47, ref48;
            if (!!(el === null || el === void 0 ? void 0 : (ref = el.benefit) === null || ref === void 0 ? void 0 : (ref46 = ref.gifts) === null || ref46 === void 0 ? void 0 : ref46.length)) {
                gifts = _toConsumableArray(gifts).concat(_toConsumableArray(el.benefit.gifts));
            }
            if (el === null || el === void 0 ? void 0 : (ref47 = el.benefit) === null || ref47 === void 0 ? void 0 : (ref48 = ref47.voucher) === null || ref48 === void 0 ? void 0 : ref48.name) {
                vouchers.push(el.benefit.voucher);
            }
        });
        var newProduct = {
            sku: skuVariant,
            quantity: quantity,
            image: product.productInfo.imageUrl,
            name: product.productInfo.name,
            selectedVariant: (convertedProduct.selected || []).map(function(v) {
                return v.value;
            }),
            supplierRetailPrice: Number(product === null || product === void 0 ? void 0 : (ref50 = product.prices) === null || ref50 === void 0 ? void 0 : (ref40 = ref50[0]) === null || ref40 === void 0 ? void 0 : ref40.supplierRetailPrice) || 0,
            latestPrice: calculatePriceByCart ? latestPrice : Number(selectionPromotion === null || selectionPromotion === void 0 ? void 0 : (ref41 = selectionPromotion.price) === null || ref41 === void 0 ? void 0 : ref41.sellPrice) || (convertedProduct === null || convertedProduct === void 0 ? void 0 : (ref42 = convertedProduct.price) === null || ref42 === void 0 ? void 0 : ref42.priceWithoutSelectionPromotion) || Number(product === null || product === void 0 ? void 0 : (ref43 = product.prices) === null || ref43 === void 0 ? void 0 : (ref44 = ref43[0]) === null || ref44 === void 0 ? void 0 : ref44.latestPrice) || 0,
            selectionPromotionId: selectionPromotionId,
            defaultPromotions: (convertedProduct === null || convertedProduct === void 0 ? void 0 : convertedProduct.defaultPromotions) || [],
            selectionPromotion: selectionPromotion,
            selectionPromotions: (convertedProduct === null || convertedProduct === void 0 ? void 0 : convertedProduct.selectionPromotions) || [],
            allowSelectPromotion: true,
            totalAvailable: product.totalAvailable,
            gifts: gifts,
            vouchers: vouchers,
            saveWithoutSelectionPromotion: calculatePriceByCart ? saveWithoutSelectionPromotion : convertedProduct.saveWithoutSelectionPromotion,
            productConfigurations: convertedProduct.productGroup.configurations,
            priceWithoutSelectionPromotion: calculatePriceByCart ? priceWithoutSelectionPromotion : convertedProduct === null || convertedProduct === void 0 ? void 0 : (ref45 = convertedProduct.price) === null || ref45 === void 0 ? void 0 : ref45.priceWithoutSelectionPromotion
        };
        setConvertProduct(newProduct);
    }, [
        JSON.stringify(product),
        selectionPromotionId,
        quantity,
        latestPrice,
        saveWithoutSelectionPromotion,
        priceWithoutSelectionPromotion, 
    ]);
    var onFinish = function(callback) {
        callback(index1, convertProduct);
    };
    return {
        product: convertProduct,
        onChangeVariant: onChangeVariant,
        onChangeQuantity: setQuantity,
        onChangeSelectionPromotionId: setSelectionPromotionId,
        onFinish: onFinish,
        loading: isLoading,
        selectionPromotionId: selectionPromotionId
    };
};
var useDynamicSelectedProduct = function(restSkus, payload) {
    var ref53 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(payload), payloadCombo = ref53[0], setPayloadCombo = ref53[1];
    var ref51 = (0,_useDiscovery__WEBPACK_IMPORTED_MODULE_5__/* .useRecommendationComboDetail */ .lR)(payloadCombo, true), _result = ref51.result, dataDynamicCombo = _result.combo, isLoadingDynamicCombo = ref51.isLoading;
    var ref52 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), convertProduct = ref52[0], setConvertProduct = ref52[1];
    var onChangeVariant = function(variant, index) {
        var ref;
        var product = (ref = dataDynamicCombo.products.find(function(el) {
            return !restSkus.includes(el.product.productInfo.sku);
        })) === null || ref === void 0 ? void 0 : ref.product;
        if (!product) return;
        var newSku = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .getNewVariant */ .A8)(product, variant, index);
        if (!!newSku) {
            var newPayloadCombo = _objectSpread({}, payloadCombo);
            newPayloadCombo.comboLineItems = payloadCombo.comboLineItems.map(function(lineItem) {
                if (lineItem.sku === product.productInfo.sku) return {
                    sku: newSku,
                    quantity: lineItem.quantity
                };
                return lineItem;
            });
            setPayloadCombo(newPayloadCombo);
        }
    };
    var onFinish = function(callback) {
        callback(payloadCombo);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref60, ref54, ref55, ref56;
        if (!dataDynamicCombo) return null;
        var comboProduct = dataDynamicCombo.products.find(function(el) {
            return !restSkus.includes(el.product.productInfo.sku);
        });
        if (!comboProduct) return null;
        var product = comboProduct.product;
        var convertedProduct = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .convertProductDetail */ .NP)(product);
        var gifts = [];
        var vouchers = [];
        (product.defaultPromotions || []).forEach(function(el) {
            var ref, ref57, ref58, ref59;
            if (!!(el === null || el === void 0 ? void 0 : (ref = el.benefit) === null || ref === void 0 ? void 0 : (ref57 = ref.gifts) === null || ref57 === void 0 ? void 0 : ref57.length)) {
                gifts = _toConsumableArray(gifts).concat(_toConsumableArray(el.benefit.gifts));
            }
            if (el === null || el === void 0 ? void 0 : (ref58 = el.benefit) === null || ref58 === void 0 ? void 0 : (ref59 = ref58.voucher) === null || ref59 === void 0 ? void 0 : ref59.name) {
                vouchers.push(el.benefit.voucher);
            }
        });
        var supplierRetailPrice = Number(product === null || product === void 0 ? void 0 : (ref60 = product.prices) === null || ref60 === void 0 ? void 0 : (ref54 = ref60[0]) === null || ref54 === void 0 ? void 0 : ref54.supplierRetailPrice) || 0;
        var latestPrice = Number(product === null || product === void 0 ? void 0 : (ref55 = product.prices) === null || ref55 === void 0 ? void 0 : (ref56 = ref55[0]) === null || ref56 === void 0 ? void 0 : ref56.latestPrice) || 0;
        var newProduct = {
            sku: product.productInfo.sku,
            quantity: comboProduct.quantity,
            image: product.productInfo.imageUrl,
            name: product.productInfo.name,
            selectedVariant: (convertedProduct.selected || []).map(function(v) {
                return v.value;
            }),
            supplierRetailPrice: supplierRetailPrice,
            latestPrice: latestPrice,
            defaultPromotions: (product === null || product === void 0 ? void 0 : product.promotions) || [],
            selectionPromotions: [],
            allowSelectPromotion: false,
            totalAvailable: product.totalAvailable,
            gifts: gifts,
            vouchers: vouchers,
            saveWithoutSelectionPromotion: supplierRetailPrice - latestPrice,
            productConfigurations: convertedProduct.productGroup.configurations
        };
        setConvertProduct(newProduct);
    }, [
        JSON.stringify(dataDynamicCombo),
        JSON.stringify(restSkus)
    ]);
    return {
        product: convertProduct,
        onChangeVariant: onChangeVariant,
        onFinish: onFinish,
        loading: isLoadingDynamicCombo
    };
};


/***/ })

}]);